/** 1 = Monday … 7 = Sunday (backend convention) */
const DAY = [
  "",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

/**
 * Present recurring_weekly days: e.g. "Every Monday", "Every Monday - Friday",
 * "Every Saturday - Sunday", "Every Monday, Wednesday and Friday".
 *
 * @param {number[]|undefined|null} daysOfWeek
 * @returns {string}
 */
export const formatRecurringWeeklyDaysDisplay = (daysOfWeek) => {
  if (!daysOfWeek?.length) return "";
  const days = [...new Set(daysOfWeek.filter((d) => d >= 1 && d <= 7))].sort(
    (a, b) => a - b,
  );
  if (days.length === 0) return "";
  if (days.length === 7) return "Everyday";
  if (days.length === 5 && days[0] === 1 && days[4] === 5) {
    return "Every Monday - Friday";
  }
  if (days.length === 2 && days[0] === 6 && days[1] === 7) {
    return "Every Saturday - Sunday";
  }

  const runs = [];
  let runStart = days[0];
  let runEnd = days[0];
  for (let i = 1; i < days.length; i++) {
    if (days[i] === runEnd + 1) {
      runEnd = days[i];
    } else {
      runs.push([runStart, runEnd]);
      runStart = days[i];
      runEnd = days[i];
    }
  }
  runs.push([runStart, runEnd]);

  const formatRun = ([a, b]) => {
    if (a === b) return `Every ${DAY[a]}`;
    return `Every ${DAY[a]} - ${DAY[b]}`;
  };

  if (runs.length === 1) return formatRun(runs[0]);

  const allSingleDays = runs.every(([a, b]) => a === b);
  if (allSingleDays) {
    const names = runs.map(([a]) => DAY[a]);
    if (names.length === 2) return `Every ${names[0]} and ${names[1]}`;
    return `Every ${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
  }

  const parts = runs.map(formatRun);
  if (parts.length === 2) return `${parts[0]} and ${parts[1]}`;
  return `${parts.slice(0, -1).join(", ")} and ${parts[parts.length - 1]}`;
};
